import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import { brandConfig } from "config/brandConfig";
import { useEffect } from "react";
import SEOMeta from "components/SEOMeta";
import { Link } from "react-router-dom";

export default function ConditionsGenerales() {
  const lastUpdated = new Date().toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }); // mets à jour si besoin

  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([
      { label: "Accueil", href: "/" },
      { label: "Conditions générales" },
    ]);
  }, [setItems]);

  return (
    <>
      <SEOMeta
        title="Conditions générales"
        description={`Conditions générales de vente et d’utilisation de ${brandConfig.brandName}.`}
        canonicalPath="/conditions-generales"
      />
      <main
        role="main"
        style={{ maxWidth: 960, margin: "0 auto", padding: "24px 16px" }}
      >
        <h1 style={{ marginTop: 12 }}>
          Conditions générales de vente et d’utilisation
        </h1>
        <p style={{ fontSize: 14, opacity: 0.8, marginTop: 4 }}>
          Dernière mise à jour : {lastUpdated}
        </p>

        <section id="societe" style={{ marginTop: 24 }}>
          <h2>1) Informations sur la société</h2>
          <p>
            <strong>M4Sécurité</strong>
          </p>
          <address style={{ fontStyle: "normal" }}>
            11 Rue Raspail, 94230 Cachan, France
          </address>
          <ul>
            <li>
              E-mail :{" "}
              <Link to="mailto:contact@kaisersafe.com">
                contact@kaisersafe.com
              </Link>
            </li>
            <li>
              Téléphone : <a href="tel:+33785756439">+33 78 575 64 39</a>
            </li>
          </ul>
        </section>

        <section id="objet" style={{ marginTop: 24 }}>
          <h2>2) Objet</h2>
          <p>
            Les présentes conditions générales définissent les modalités de
            vente et d’utilisation du site exploité par{" "}
            <strong>M4Sécurité</strong>. Toute commande implique l’acceptation
            sans réserve des présentes CGV/CGU.
          </p>
        </section>

        <section id="produits" style={{ marginTop: 24 }}>
          <h2>3) Produits et disponibilité</h2>
          <p>
            Les produits proposés sont décrits et présentés avec la plus grande
            exactitude possible. Toutefois, des différences minimes peuvent
            exister (photos non contractuelles). La disponibilité des produits
            est indiquée au moment de la commande.
          </p>
        </section>

        <section id="garantie" style={{ marginTop: 24 }}>
          <h2>4) Garanties</h2>
          <p>
            Nos produits bénéficient des garanties légales prévues par le Code
            des obligations suisse. La garantie contractuelle éventuelle est
            précisée dans la fiche produit.
          </p>
        </section>

        <section id="responsabilite" style={{ marginTop: 24 }}>
          <h2>5) Responsabilité</h2>
          <p>
            <strong>M4Sécurité</strong> décline toute responsabilité en cas de
            mauvaise utilisation du produit, d’usure normale, de force majeure
            ou d’interventions non autorisées sur le produit.
          </p>
        </section>

        <section id="propriete-intellectuelle" style={{ marginTop: 24 }}>
          <h2>6) Propriété intellectuelle</h2>
          <p>
            Tous les contenus (textes, images, logos, vidéos, etc.) du site sont
            protégés par le droit d’auteur et restent la propriété exclusive de{" "}
            <strong>M4Sécurité</strong>.
          </p>
        </section>

        <section id="donnees" style={{ marginTop: 24 }}>
          <h2>7) Protection des données</h2>
          <p>
            Le traitement des données personnelles est régi par notre{" "}
            <Link to="/politique-de-confidentialite">
              Politique de confidentialité
            </Link>
            .
          </p>
        </section>

        <section id="litiges" style={{ marginTop: 24 }}>
          <h2>8) Droit applicable et juridiction compétente</h2>
          <p>
            Les présentes conditions sont régies par le droit suisse. En cas de
            litige, les tribunaux compétents sont ceux du canton de Vaud, sous
            réserve d’un recours au Tribunal fédéral.
          </p>
        </section>

        <section id="contact" style={{ marginTop: 24 }}>
          <h2>9) Contact</h2>
          <p>
            Pour toute question relative aux présentes conditions, veuillez nous
            contacter à :{" "}
            <a href="mailto:contact@kaisersafe.com">contact@kaisersafe.com</a>{" "}
            ou par téléphone au <a href="tel:+33785756439">+33 78 575 64 39</a>.
          </p>
        </section>
        <section id="commande" style={{ marginTop: 24 }}>
          <h2>10) Commande</h2>
          <p>
            KaiserSafe ne vend pas ses articles en direct et suit une politique
            de distribution par revendeurs. Afin de pouvoir contacter l'un de
            nos partenaires, veuillez visiter la page{" "}
            <a style={{ color: "blue" }} href="/revendeurs">
              Nos Revendeurs
            </a>
            .
          </p>
        </section>

        <hr style={{ marginTop: 24, marginBottom: 12 }} />
        <p style={{ fontSize: 12, opacity: 0.7 }}>
          <em>
            Modèle de conditions générales adapté au droit suisse (Code des
            obligations, LCD). Personnaliser selon les spécificités (types de
            produits, politique de retours précise, modes de paiement réels,
            transporteurs).
          </em>
        </p>
      </main>
    </>
  );
}
